import angular from "angular";
import angularUIB from "angular-ui-bootstrap";
import mobiusRequestLog from "../mobius-request-log";
import core from "../../core/core.module";
import requestInfo from "../request-info/request-info.component";
import angularMoment from "angular-moment";

angular
    .module('mobiusControl.requestLogs', [angularUIB, mobiusRequestLog, core, requestInfo, angularMoment])
    .component('requestLogs', {
        template: require('./request-logs.component.html'),
        controller: ['MobiusRequestLog', 'notifier', '$uibModal', 'moment', 'Data', controller],
        bindings: {
            requestSlugs: '<',
            params: '<'
        }
    });

function controller(MobiusRequestLog, notifier, $uibModal, moment, Data) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.currentPage = 1;
        $ctrl.id = null;
        $ctrl.user = null;
        $ctrl.requestSlug = null;
        $ctrl.status = null;
        $ctrl.startDate = null;
        $ctrl.endDate = null;

        if ($ctrl.params.id) {
            $ctrl.id = $ctrl.params.id;
        }

        $ctrl.getList();
    };

    $ctrl.filterChanged = function () {
        $ctrl.currentPage = 1;
        $ctrl.getList();
    };

    $ctrl.clearFilter = function () {
        $ctrl.id = null;
        $ctrl.user = null;
        $ctrl.requestSlug = null;
        $ctrl.status = null;
        $ctrl.startDate = null;
        $ctrl.endDate = null;
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        let startDate = null;
        let endDate = null;
        if ($ctrl.startDate) {
            startDate = moment($ctrl.startDate).format('YYYY-MM-DD HH:mm:ss');
        }
        if ($ctrl.endDate) {
            endDate = moment($ctrl.endDate).format('YYYY-MM-DD HH:mm:ss');
        }
        MobiusRequestLog
            .getList({
                currentPage: $ctrl.currentPage,
                id: $ctrl.id,
                userId: $ctrl.user ? $ctrl.user.id : null,
                requestSlug: $ctrl.requestSlug,
                status: $ctrl.status,
                startDate: startDate,
                endDate: endDate
            })
            .then(
                function (response) {
                    $ctrl.requestLogs = response.data.requestLogs;
                    $ctrl.totalCount = response.data.totalCount;
                },
                function (error) {
                    notifier.errorResponseNotify(error);
                }
            );
    };

    $ctrl.openItem = function (item) {
        if (item.fullData) {
            openModal(item.fullData);
        } else {
            MobiusRequestLog
                .getItem(item.id)
                .then(
                    function (response) {
                        item.fullData = response.data.requestLog;
                        openModal(item.fullData);
                    },
                    function (error) {
                        notifier.errorResponseNotify(error);
                    }
                );
        }
    };

    function openModal(logData) {
        $uibModal
            .open({
                component: 'requestInfo',
                resolve: {
                    requestLog: function () {
                        return logData;
                    }
                },
                size: 'lg'
            });
    }

    $ctrl.getUsers = function (search) {
        return Data.getUsers(search);
    }
}

export default "mobiusControl.requestLogs"


// WEBPACK FOOTER //
// ./resources/assets/modules/mobius-control/request-logs/request-logs.component.js